export const DO_VOUCHER = 'DO';
export const CR_VOUCHER = 'CR';
export const PROMO_ID = 'PROMO';
export const NEW_CARD_OPTION = 'new_card';
export const CARD_PAYMENT = 'card-payment';
export const UPLIFT_PAYMENT = 'uplift-payment';
export const INSTANT_CREDIT_CARD = 'instant_credit_card';
export const PAYPAL = 'PL';
export const PAYPAL_PAYLATER = 'PPL';

// upsell constants
export const UPSELL_TRAVEL_INSURANCE = 'TRAVEL_INSURANCE';
